// utils/handleOnPopState.js
import { uploadToS3V2 } from '../db/aws_s3_utils.js';
import config from "./conf.js";

export const handleOnPopState = async ({
  results,
  userData,
  navigate,
  location,
}) => {
  if (window.confirm("If you leave now you will have to restart the test. Are you sure you want to leave?")) {
    const serializedResults = JSON.stringify(results ?? JSON.parse(localStorage.getItem("results") || "{}"));
    const params = {
      baseUrl: config.COGNET_DB_API_URL,
      patientId: userData.UUID,
      dbName: userData.origin,
      testType: userData.examType,
      attempt: userData.attemptNumber,
      screenId: "results",
      extension: "JSON",
      contentType: "application/json",
      fileBuffer: new Blob([serializedResults], { type: "application/json" })
    };

    try {
      await uploadToS3V2(params);
    } catch (error) {
      console.error("Failed to upload JSON to S3:", error);
    }
    navigate("/");
  } else {
    navigate(location.pathname);
  }
};
